<template>
  <div>
    <div class="flex flex-col border rounded">
      <expandable title="Basic Settings" class="bg-gray-200" :startsOpen="true">
        <div slot="title" class='flex items-end flex-1 p-3 w-full rounded space-x-1'>
          <p class='font-bold'>Settings - </p>
          <p class="">{{selectedTemplate.config.name}} classes by {{selectedTemplate.config.break_type}}</p>
        </div>
        <div slot="expandable" class="bg-white">
          <div id="quick_settings" class="w-full">

            <div id="base_settings">
              <!--<div class="bg-gray-200 border-b py-1 px-3">
                <p class="text-lg font-semibold">Base Settings</p>
              </div>-->
              <div class="px-4 py-3 border-b">
                <div class="flex justify-between mb-2 items-center">
                  <p class="text-lg font-semibold">Base Settings</p>
                  <div class="relative flex items-center">
                    <div class="flex h-5 items-center">
                      <input v-model="selectedTemplate.config.advanced_name_settings" @change="checkForAdvancedReset" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
                    </div>
                    <div class="ml-1 text-sm">
                      <div class="flex items-center space-x-1">
                        <label for="comments" class="font-medium text-gray-700">Advanced Name Settings</label>
                        <!--<span v-tooltip="{content: advancedNameSettingsHelpText}">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                          </svg>
                        </span>-->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-full flex flex-col md:flex-row md:space-x-4 space-y-3 md:space-y-0">
                  <div class="flex space-x-4">
                    <div class="w-72">
                      <div class="flex justify-between items-end">
                        <div class="flex items-center space-x-1">
                          <label for="base_name" class="block text-sm font-medium leading-6 text-gray-900">Base Name</label>
                          <span v-tooltip="{content: baseNameHelpText}">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                            </svg>
                          </span>
                        </div>
                      </div>
                      <div class="mt-1">
                        <input v-model="selectedTemplate.config.name" type="text" name="base_name" id="base_name" class="block w-full rounded-md px-2 py-1 text-gray-900 shadow-sm border border-gray-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" placeholder="" aria-describedby="base_name-description">
                      </div>
                      <div class="relative flex items-center mt-1">
                        <div class="flex h-5 items-center">
                          <input v-model="selectedTemplate.config.no_name_in_class" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
                        </div>
                        <div class="ml-1 text-sm">
                          <div class="flex items-center space-x-1">
                            <label for="comments" class="font-medium text-gray-700">Don't use in Division Name</label>
                            <span v-tooltip="{content: noClassNameHelpText}">
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class=" w-40">
                      <div class="flex items-center space-x-1">
                        <label for="break_type" class="block text-sm font-medium leading-6 text-gray-900">Base Break Type</label>
                        <span v-tooltip="{content: baseBreakHelpText}">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                          </svg>
                        </span>
                      </div>
                      <div class="mt-1">
                        <v-select
                          class="rounded"
                          v-model="selectedTemplate.config.break_type"
                          :options="['weight','age','none']"
                          :reduce="option => option"
                          :clearable="false"
                          @input="breakTypeChanged"
                        >
                        </v-select>
                      </div>
                    </div>
                  </div>
                  <div class="flex space-x-4">
                    <div class="w-56" v-if="selectedTemplate.config.advanced_name_settings && !classes && (hasAgeSettings)">
                      <div class="flex items-center space-x-1">
                        <div class="w-4"></div>
                        <label for="base_name" class="ml-2 block text-sm font-semibold leading-6 text-gray-900">Show Ages In Class Name</label>
                      </div>
                      <div class="relative flex items-center mt-1">
                        <div class="flex h-5 items-center">
                          <input v-model="selectedTemplate.config.show_age_in_division_name" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
                        </div>
                        <div class="ml-2 text-sm">
                          <div class="flex items-center space-x-1">
                            <label for="comments" class="font-medium text-gray-700">Include the age/date ranges in the class name.</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-72" v-if="selectedTemplate.config.advanced_name_settings">
                      <div class="flex justify-between items-end">
                        <div class="flex items-center space-x-1">
                          <label for="base_name" class="block text-sm font-medium leading-6 text-gray-900">Champion Base Name</label>
                          <span v-tooltip="{content: championNameHelpText}">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                            </svg>
                          </span>
                        </div>
                      </div>
                      <div class="mt-1">
                        <input v-model="selectedTemplate.config.champion_name" placeholder="It's okay to leave this blank if not needed." type="text" name="base_name" id="base_name" class="block w-full rounded-md px-2 py-1 text-gray-900 shadow-sm border border-gray-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" aria-describedby="base_name-description">
                      </div>
                      <div class="relative flex items-center mt-1">
                        <div class="flex h-5 items-center">
                          <input v-model="selectedTemplate.config.no_name_in_div_champion_class" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
                        </div>
                        <div class="ml-1 text-sm">
                          <div class="flex items-center space-x-1">
                            <label for="comments" class="font-medium text-gray-700">Don't use in Divisions</label>
                            <span v-tooltip="{content: noDivChampionNameHelpText}">
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="champion_settings">
              <!--<div class="bg-gray-200 py-1 px-3 border-t border-b">
                <p class="text-lg font-semibold">Champion Settings</p>
              </div>-->
              <div class="px-4 border-b py-3">
                <p class="text-lg font-semibold">Champion Settings</p>
                <div class="w-full ">
                  <div class="w-full flex flex-col md:flex-row md:space-x-4 space-y-1.5 md:space-y-0">
                    <div>
                      <div class="flex items-center space-x-1">
                        <label for="champions" class="block text-sm font-medium leading-6 text-gray-900"># Overall Champions</label>
                        <span v-tooltip="{content: overallChampionHelpText}">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                          </svg>
                        </span>
                      </div>
                      <div class="mt-1">
                        <input v-model="selectedTemplate.config.champions" type="number" name="champions" id="champions" class="block w-full rounded-md px-2 py-1 text-gray-900 shadow-sm border border-gray-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" placeholder="" aria-describedby="champions-description">
                      </div>
                    </div>
                    <div v-if="selectedTemplate.config.champions > 0" class='md:w-48'>
                      <div class="flex items-center space-x-1">
                        <label for="champions_title" class="block text-sm font-medium leading-6 text-gray-900">Overall Champion Title</label>
                        <span v-tooltip="{content: overallChampionTitleHelpText}">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                          </svg>
                        </span>
                      </div>
                      <select v-model="selectedTemplate.config.champion_title" id="location" name="location" class="mt-1 block w-full rounded-md border border-gray-400 py-1.5 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
                        <option :value="null" selected disabled>
                          Please select the break type
                        </option>
                        <option v-for="(o, ci) in championTitleOptions" :key="ci" :value="o.value">{{ o.label }}</option>
                      </select>
                    </div>

                    <div>
                      <div class="flex items-center space-x-1">
                        <label for="division_champions" class="block text-sm font-medium leading-6 text-gray-900"># Division Champions</label>
                        <span v-tooltip="{content: divisionChampionHelpText}">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                          </svg>
                        </span>
                      </div>
                      <div class="mt-1">
                        <input @change="divisionChampionsChanged" v-model="selectedTemplate.config.division_champions" type="number" name="division_champions" id="division_champions" class="block w-full rounded-md px-2 py-1 text-gray-900 shadow-sm border border-gray-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" aria-describedby="division_champions-description">
                      </div>
                    </div>
                    <div v-if="selectedTemplate.config.division_champions > 0" class='md:w-48'>
                      <div class="flex items-center space-x-1">
                        <label for="champions_title" class="block text-sm font-medium leading-6 text-gray-900">Division Champion Title</label>
                        <span v-tooltip="{content: divisionChampionTitleHelpText}">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                          </svg>
                        </span>
                      </div>
                      <select @change="divisionChampionTitleChanged" v-model="selectedTemplate.config.division_champion_title" id="location" name="location" class="mt-1 block w-full rounded-md border border-gray-400 py-1.5 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
                        <option :value="null" selected disabled>
                          Please select the break type
                        </option>
                        <option v-for="(o, ci) in championTitleOptions" :key="ci" :value="o.value">{{ o.label }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="age_settings" v-if="selectedTemplate.config.break_type === 'age' && level === 0">
              <!--<div class="bg-gray-200 py-1.5 px-3 border-b border-t">
                <p class="text-lg font-semibold">Age Settings</p>
              </div>-->
              <div class="px-4 py-3">
                <p class="text-lg font-semibold">Age Settings</p>
                <div class="w-full" >
                  <div class="w-full flex flex-col md:flex-row md:space-x-4 space-y-1.5 md:space-y-0">
                    <div class="mb-1 w-full md:w-48">
                      <div class="flex items-center space-x-1">
                        <label for="champions" class="block text-sm font-medium leading-6 text-gray-900">Preset Age Classes By</label>
                        <span v-tooltip="{content: ageCalcTypeHelpText}">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                          </svg>
                        </span>
                      </div>
                      <div class="mt-1">
                        <select v-model="selectedTemplate.config.class_calc" id="location" name="location" class="mt-1 block w-full rounded-md border border-gray-400 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
                          <option :value="null" selected disabled>
                            Please select calc type
                          </option>
                          <option value='date_range'>Date Range</option>
                          <option value='age'>Specific Age</option>
                          <option value='none'>None</option>
                        </select>
                      </div>
                    </div>
                    <template v-if="selectedTemplate.config.class_calc === 'age'">
                      <div class="w-full md:w-72">
                        <div class="flex justify-between items-end">
                          <div class="flex items-center space-x-1">
                            <label for="base_date" class="block text-sm font-medium leading-6 text-gray-900">Base Date</label>
                            <span v-tooltip="{content: baseDateHelpText}">
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                              </svg>
                            </span>
                          </div>
                          <div class="relative flex items-center mt-1">
                            <div class="flex h-5 items-center">
                              <input v-model="selectedTemplate.config.base_date_day_of_show" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-400 text-indigo-600 focus:ring-indigo-500">
                            </div>
                            <div class="ml-1 text-sm">
                              <div class="flex items-center space-x-1">
                                <label for="comments" class="font-medium text-gray-700">Use Day of Show</label>
                                <span v-tooltip="{content: useDayOfShowHelpText}">
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                  </svg>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-1">
                          <input v-model="selectedTemplate.config.base_date" :disabled="selectedTemplate.config.base_date_day_of_show" :class="{'cursor-not-allowed' : selectedTemplate.config.base_date_day_of_show, 'bg-gray-300' : selectedTemplate.config.base_date_day_of_show}" type="date" name="champions" id="champions" class="block w-full rounded-md px-2 py-1 text-gray-900 shadow-sm border border-gray-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" placeholder="" aria-describedby="champions-description">
                        </div>
                      </div>
                      <div class="w-full md:w-64">
                        <div class="flex justify-between items-end">
                          <label for="champions" class="block text-sm font-medium leading-6 text-gray-900">Age Unit</label>
                          <div class="relative flex items-center mt-1">
                            <div class="flex h-5 items-center">
                              <input v-model="selectedTemplate.config.age_gap" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
                            </div>
                            <div class="ml-1 text-sm">
                              <div class="flex items-center space-x-1">
                                <label for="comments" class="font-medium text-gray-700">Use Age Gap?</label>
                                <span v-tooltip="{content: ageGapHelpText}">
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                  </svg>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-1">
                          <select v-model="selectedTemplate.config.age_unit" id="location" name="location" class="mt-1 block w-full rounded-md border border-gray-400 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
                            <option :value="null" selected disabled>
                              Please select age unit
                            </option>
                            <option value='YEARS'>Years</option>
                            <option value='MONTHS'>Months</option>
                          </select>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </expandable>

      <expandable ref="divExpandable" title="Divisions" class="bg-gray-200">
        <div slot="title" class='flex justify-between items-center flex-1 p-3 space-x-1 w-full rounded'>
          <p class="font-bold">Divisions <span clsss="font-medium">({{divisions}})</span></p>
          <!--<div v-if="!addDivisions && !editingDivision && $refs.divExpandable.isOpen" class="text-right flex justify-between space-x-2 items-end">
            <div class="flex space-x-1 items-center">
              <input v-model="customDivisionName" @keyup.enter="addCustomDivision" type="text" name="customDivision" id="customDivision" class="w-40_  p-1 border rounded text-sm border-gray-400" placeholder="Custom Division">
              <button class="text-xs font-medium border border-green-600 py-1 px-1 rounded text-white bg-green-600 hover:bg-green-800" @click="addCustomDivision">Add Custom</button>
            </div>
            <dropdown-button  ref="addDivision">
              <span slot="link" class="appearance-none flex text-xs font-medium border border-blue-600 py-1 px-1 rounded text-white bg-blue-600">
                <span class="mr-1">Add Breeds</span>
                <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path style="fill:white;" d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </span>
              <div slot="dropdown" class="text-right border max-h-screen origin-top-right absolute right-0 mt-2 w-56 rounded-lg shadow-lg bg-white ring-1 border-gray-800 border-opacity-25 divide-y divide-gray-100 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                <div class="py-1 divide-y divide-gray-200" role="none">
                  <a href="#" @click="addDivisionsClicked('breed')" class="block px-4 py-1 text-base text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem" tabindex="-1" id="menu-item-0">Add Breed Divisions</a>
                  <a href="#" @click="addDivisionsClicked('breed_group')" class="block px-4 py-1 text-base text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem" tabindex="-1" id="menu-item-0">Create Breed Group</a>
                </div>
              </div>
            </dropdown-button>
          </div> -->
        </div>
        <div slot="expandable" class="bg-white">
          <div id="divisions" class="w-full border_">
            <div v-if="!editingDivision" class_="border-b border-t px-4 py-3 bg-gray-200" class="px-4 py-2 border-b">
              <div class="flex justify-end items-end">
                <div v-if="!addDivisions" class="text-right flex justify-between space-x-2 items-end">
                  <div class="flex space-x-1 items-center">
                    <input v-model="customDivisionName" @keyup.enter="addCustomDivision" type="text" name="customDivision" id="customDivision" class="w-40_  p-1 border rounded text-sm border-gray-400" placeholder="Custom Division">
                    <button class="text-xs font-medium border border-green-600 py-1 px-1 rounded text-white bg-green-600 hover:bg-green-800" @click="addCustomDivision">Add Custom</button>
                  </div>
                  <dropdown-button  ref="addDivision">
                    <span slot="link" class="appearance-none flex text-xs font-medium border border-blue-600 py-1 px-1 rounded text-white bg-blue-600">
                      <span class="mr-1">Add Breeds</span>
                      <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path style="fill:white;" d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </span>
                    <div slot="dropdown" class="text-right border max-h-screen origin-top-right absolute right-0 mt-2 w-56 rounded-lg shadow-lg bg-white ring-1 border-gray-800 border-opacity-25 divide-y divide-gray-100 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                      <div class="py-1 divide-y divide-gray-200" role="none">
                        <a href="#" @click="addDivisionsClicked('breed')" class="block px-4 py-1 text-base text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem" tabindex="-1" id="menu-item-0">Add Breed Divisions</a>
                        <a href="#" @click="addDivisionsClicked('breed_group')" class="block px-4 py-1 text-base text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem" tabindex="-1" id="menu-item-0">Create Breed Group</a>
                      </div>
                    </div>
                  </dropdown-button>
                </div>
              </div>
            </div>
            <div class="">
              <div v-if="addDivisions" class="bg-gray-200 rounded-md p-5 mt-4 border">
                <template v-if="addDivisionType === 'breed' || addDivisionType === 'breed_group'">
                  <div class="flex justify-between">
                    <div>
                      <div v-if="addDivisionType === 'breed_group'" class="mb-1">
                        <label class="font-medium">Breed Group Name:</label>
                        <input v-model="breedGroupName" class="mt-1 w-full p-1 border rounded">
                      </div>
                      <p v-else class="font-semibold text-lg">Available Divisions</p>
                      <p class="text-sm mb-2">Select which breeds your would like to add:</p>
                    </div>
                    <div>
                      <button class="text-sm btn-link mr-2" @click="addDivisions = false">Cancel</button>
                      <button class="text-base font-medium border border-green-600 py-1 px-2 rounded text-green-600 hover:text-white hover:bg-green-600" @click="addSelectedDivisions">{{ addDivisionType === 'breed_group' ? 'Save Breed Group' : 'Add Breeds' }}</button>
                    </div>
                  </div>
                  <div v-for="b in availableDivisions" :key="b.id" class="py-1">
                    <div class="flex items-center">
                      <input type="checkbox" :value="b.id" v-model="b.include" :id="b.id" class="mr-1 h-4 w-4">
                      <select v-if="b.alias.length > 0" v-model="b.name" class="rounded-md px-1 py-0.5 text-gray-900 shadow-sm border border-gray-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-sm sm:leading-6">
                        <option v-for="a in b.alias" :key="a" :value="a">
                          {{ a }}
                        </option>
                      </select>
                      <label v-else :for="b.id" class="text-sm font-medium px-1">{{ b.name }}</label>
                    </div>
                    <div v-if="b.variants.length" class="ml-3 mt-0.5 pl-1 border-l border-gray-600">
                      <div v-for="v in b.variants" :key="v.name" class="flex items-center mb-0.5">
                        <input type="checkbox" :value="b.id" v-model="v.include" :id="v.id" class="mr-1 h-4 w-4">
                        <label :for="b.id" class="text-sm font-medium">{{ v.name }}</label>
                      </div>
                    </div>
                  </div>
                </template>
                <div class="flex justify-end mt-4">
                  <button class="text-sm btn-link mr-2" @click="addDivisions = false">Cancel</button>
                  <button class="text-base font-medium border border-green-600 py-1 px-2 rounded text-green-600 hover:text-white hover:bg-green-600" @click="addSelectedDivisions">{{ addDivisionType === 'breed_group' ? 'Save Breed Group' : 'Add Breeds' }}</button>
                </div>
              </div>
              <template v-else-if="divisions">
                <draggable tag="div" v-model="selectedTemplate.config.divisions" ghost-class="ghost" handle=".handle" class="bg-white divide-y divide-gray-200 w-full">
                  <template v-if="!advancedDivisionEditing">
                    <div v-for="(d, i) in selectedTemplate.config.divisions" :key="i" class="px-4 py-2 flex items-center bg-white" :class="{'bg-blue-300': d.edit, 'bg-opacity-50': d.edit}">
                      <div v-if="!editingDivision" class="handle draggable mr-3">&#9776;</div>
                      <div class="w-full" :class="{'': d.edit}">
                        <template v-if="!d.edit">
                          <div class="flex flex-col md:flex-row md:justify-between md:items-center">
                            <div class="w-64 lg:w-96 flex-shrink-0">
                              <div class="text-xs text-gray-700">
                                <span v-if="d.division_type === 'breed' || isBreed(d)" class_="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700 border border-inset border-blue-700 border-opacity-25">Breed</span>
                                <span v-else-if="d.division_type === 'breed_group'" class_="inline-flex items-center rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-700 border border-inset border-green-600 border-opacity-25">Breed Group</span>
                                <span v-else-if="d.division_type === 'custom'" class_="inline-flex items-center rounded-full bg-purple-100 px-2 py-0.5 text-xs font-medium text-purple-700 border border-inset border-purple-700 border-opacity-25">Custom</span>
                              </div>
                              <p class="text-base font-medium">{{ d.name }} <span v-if="d.hint && !d.edit" class="text-xs text-semibold"> ({{ d.hint }})</span></p>
                              <div v-if="d.division_type === 'breed_group'">
                                <div class="text">
                                  <div v-for="b in d.breeds" :key="b" class="ml-2 text-xs">
                                    <p>{{ b }}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="flex space-x-2.5 text-gray-800 text-sm w-full flex-grow-0 items-center">
                              <p class="uppercase font-medium">{{ d.break_type }}</p>
                              <template v-if="(baseConfig.class_calc === 'age' || baseConfig.class_calc === 'date_range') && (!classes && !d.classes.length && !d.divisions.length)">
                                <template v-if="baseConfig.class_calc === 'date_range'">
                                  <p v-if="d.start_date && d.end_date">{{ formatDate(d.start_date) }} - {{ formatDate(d.end_date) }}</p>
                                  <p v-else class="font-bold bg-red-500 p-0.5 rounded">Dates Not Set</p>
                                </template>
                                <template v-else>
                                  <p v-if="(d.start_date || d.start_date === 0) && d.end_date">{{ d.start_date }}-{{ d.end_date }} {{ selectedTemplate.config.age_unit }}</p>
                                  <p v-else class="font-bold bg-red-500 p-0.5 rounded">Age Not Set</p>
                                </template>
                              </template>
                              <p>Ch: {{ d.champions }}</p>
                              <p>Sub: {{ d.division_champions }}</p>
                            </div>
                          </div>
                          <div v-if="hasDivisions(d) || hasClasses(d)" class="flex justify-start space-x-5 mt-1 pt-1 border-t pl-6">
                            <div v-if="d.divisions.length" >
                              <p class="font-bold text-xs">Sub Divisions</p>
                              <p v-for="(sd, j) in d.divisions" class="text-xs" :key="j">{{sd.name}} - {{sd.champions}} Champions</p>
                            </div>
                            <div v-if="d.classes.length" >
                              <p class="font-bold text-xs">Classes</p>
                              <p v-for="(c, j) in d.classes" class="text-xs" :key="j">{{c.class_name}}</p>
                            </div>
                          </div>
                        </template>
                        <div v-else class=''>
                          <div class="flex flex-col md:flex-row md:justify-between md:items-end">
                            <div>
                              <div class="text-xs font-semi-bold uppercase">
                                <span v-if="d.division_type === 'breed' || isBreed(d)" class_="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700 border border-inset border-blue-700 border-opacity-25">Breed Division</span>
                                <span v-else-if="d.division_type === 'breed_group'" class_="inline-flex items-center rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-700 border border-inset border-green-600 border-opacity-25">Breed Group Division</span>
                                <span v-else class_="inline-flex items-center rounded-full bg-purple-100 px-2 py-0.5 text-xs font-medium text-purple-700 border border-inset border-purple-700 border-opacity-25">Custom Division</span>
                              </div>
                              <div v-if="getBreedAliasList(d.name).length" class="mb-1">
                                <select v-model="d.name" class="rounded-md px-2 py-0.5 text-gray-900 shadow-sm border border-gray-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-base sm:leading-6">
                                  <option v-for="a in getBreedAliasList(d.name)" :key="a" :value="a"> {{ a }}</option>
                                </select>
                              </div>
                              <div v-else-if="(d.division_type === 'breed_group' || d.division_type === 'custom')" class="flex items-center text-base space-x-1_ mb-1">
                                <p></p>
                                <input v-model="d.name" type="text" name="name" id="name" class="w-32 py-1 px-2 border rounded-md" placeholder="Division Name">
                              </div>
                              <div v-else class="text-xl">
                                <input v-if="d.canEdit && !isBreed(d)" v-model="d.name" type="text" name="name" id="name" class="w-64 py-1 px-2 border rounded-md" placeholder="Division Name">
                                <p v-else>{{ d.name }}</p>
                              </div>
                            </div>
                            <div class="text-sm mt-1 w-full md:w-72">
                              <div class="flex justify-between">
                                <label class="text-sm font-medium">Hint Text</label>
                              </div>
                              <input v-model="d.hint" type="text" name="description" id="description" class="w-full p-1.5 border rounded" placeholder="Optional hint text">
                            </div>
                          </div>

                          <div v-if="d.division_type === 'breed_group'">
                            <div class="text ml-2">
                              <div v-for="b in d.breeds" :key="b" class=" text-xs">
                                <p>{{ b }}</p>
                              </div>
                              <button class="text-sm btn-link" @click="editBreedGroup(d)">Edit Breeds</button>
                            </div>
                          </div>

                          <div class="flex flex-col md:flex-row md:items-end text-sm md:space-x-2 font-light mt-2">
                            <div class="font-medium">
                              <label>Break Type: </label>
                              <select v-model="d.break_type" class="rounded-md px-2 py-0.5 text-gray-900 shadow-sm border border-gray-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-xs sm:leading-6">
                                <option value="weight">
                                  weight
                                </option>
                                <option value="age">
                                  age
                                </option>
                                <option value="none">
                                  none
                                </option>
                              </select>
                            </div>
                            <p>
                              <label class="font-medium">Ch: </label>
                              <input v-model="d.champions" type="number" name="champions" id="champions" class="p-1 w-12 border rounded" placeholder="Champions">
                            </p>
                            <p>
                              <label class="font-medium">Sub Ch: </label>
                              <input v-model="d.division_champions" type="number" name="division_champions" id="division_champions" class="p-1 w-12 border rounded" placeholder="Division Champions">
                            </p>
                            <div class="font-medium">
                              <label>Ch Title: </label>
                              <select v-model="d.champion_title" class="rounded-md px-2 py-0.5 text-gray-900 shadow-sm border border-gray-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-xs sm:leading-6">
                                <option v-for="(o, ci) in championTitleOptions" :key="ci" :value="o.value">{{ o.label }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="flex items-center text-sm space-x-2 mt-2" v-if="(baseConfig.class_calc === 'age' || baseConfig.class_calc === 'date_range') && (!classes && !d.classes.length && !d.divisions.length)">
                            <p>Start: <input v-model="d.start_date" :type="baseConfig.class_calc === 'date_range' ? 'date' : 'number'" name="champions" id="champions" class="p-1 border rounded w-32" placeholder="Start">
                            </p>
                            <p>End: <input v-model="d.end_date" :type="baseConfig.class_calc === 'date_range' ? 'date' : 'number'" name="division_champions" id="division_champions" class="p-1 border rounded w-32" placeholder="End">
                            </p>
                          </div>
                          <div class="mt-3">
                            <p class="text-sm font-medium mb-1 underline">Advanced Config</p>
                            <div class="flex justify-between items-center">
                              <div class="flex flex-col md:flex-row md:items-center md:space-x-4 text-sm">
                                <div class="relative flex items-center">
                                  <div class="flex h-4 items-center">
                                    <input id="comments" v-model="d.no_classes" aria-describedby="comments-description" name="comments" type="checkbox" class="h-3 w-3 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
                                  </div>
                                  <div class="ml-1 text-sm">
                                    <div class="flex items-center space-x-1">
                                      <label for="comments" class="font-medium text-gray-800">No Classes</label>
                                      <span v-tooltip="{content: noClassesHelpText}">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                          <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                        </svg>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="relative flex items-center">
                                  <div class="flex h-4 items-center">
                                    <input id="comments" v-model="d.admin_only" aria-describedby="comments-description" name="comments" type="checkbox" class="h-3 w-3 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
                                  </div>
                                  <div class="ml-1 text-sm">
                                    <div class="flex items-center space-x-1">
                                      <label for="comments" class="font-medium text-gray-800">Admin Only</label>
                                      <span v-tooltip="{content: adminOnlyHelpText}">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                          <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                        </svg>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="relative flex items-start">
                                  <div class="flex h-4 items-center">
                                    <input id="comments" v-model="d.use_only_division_name" aria-describedby="comments-description" name="comments" type="checkbox" class="h-3 w-3 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
                                  </div>
                                  <div class="ml-1 text-sm">
                                    <div class="flex items-start space-x-1">
                                      <label for="comments" class="font-medium text-gray-800">Use Only Division in Name</label>
                                      <span v-tooltip="{content: useOnlyDivisionNameHelpText}">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                          <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                        </svg>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <button @click="advancedDivisionEditing = true" class="btn-sm btn-gray text-xs md:text-sm">Go To Advanced Editing</button>
                            </div>
                          </div>
                          <div class="flex justify-start space-x-5 mt-2">
                            <div v-if="d.divisions.length" >
                              <p class="font-bold text-base">Sub Divisions</p>
                              <p v-for="(sd, j) in d.divisions" class="text-sm" :key="j">{{sd.name}} - {{sd.champions}} Champions</p>
                            </div>
                            <div v-if="d.classes.length" >
                              <p class="font-bold text-base">Classes</p>
                              <p v-for="(c, j) in d.classes" class="text-sm" :key="j">{{c.class_name}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="w-16 justify-end flex space-x-1 items-center pl-1">
                        <div v-if="d.edit">
                          <button @click="editingDivision.edit=false;editingDivision=null;" type="button" class="btn-xs btn-link text-sm">
                            Done
                          </button>
                        </div>
                        <template v-else>
                          <button @click="editDivision(d, i)" type="button" class="rounded-full  bg-blue-600 p-1 text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-2.5 h-2.5">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" />
                              <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                            </svg>
                          </button>
                          <button @click="removeDivisionClicked(d, i)" type="button" class="rounded-full border border-red-600 bg-red-600_ p-1 text-white shadow-sm hover:bg-red-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-2.5 h-2.5 text-red-500">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                            </svg>
                          </button>
                        </template>
                      </div>
                    </div>
                  </template>
                  <div v-else class="p-4 border-blue-600 border-4">
                    <div class="flex justify-between pb-2">
                      <p class="font-bold text-2xl"> Editing {{ editingDivision.name }}</p>
                      <div>
                        <button @click="advancedDivisionEditing = false" type="button" class="btn-sm btn-blue text-xs">
                          Done Advanced Editing
                        </button>
                      </div>
                    </div>
                    <simple-class-list-config :selectedTemplate="{config: editingDivision, class_configuration_id: this.selectedTemplate.class_configuration_id}" :breeds="breeds" :level="level + 1" :baseConfig="baseConfig"/>
                  </div>
                </draggable>
              </template>
            </div>
          </div>
        </div>
      </expandable>

      <expandable title="Classes" class="bg-gray-200">
        <div slot="title" class='flex items-center flex-1 p-3 space-x-1 w-full rounded'>
          <p class="font-bold">Classes</p>
          <p>({{classes}})</p>
        </div>
        <div slot="expandable" class="bg-white">
          <div id="classes" class="w-full ">
            <div class="px-4 py-2 border-b">
              <div class="flex justify-end items-end">
                <!--<p class="text-center text-lg font-semibold"><span>Classes:</span> {{ classes}}</p>-->
                <div class="flex space-x-2 items-end">
                  <div class="relative flex items-center" v-if="classes">
                    <div class="flex h-5 items-center">
                      <input v-model="selectedTemplate.config.class_sub_divisions" @change="setHasSubdivisions" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
                    </div>
                    <div class="ml-1 text-sm" >
                      <label for="comments" class="font-medium text-gray-700">Has Sub Divisions</label>
                    </div>
                  </div>
                  <button class="text-xs font-medium border border-green-600 py-1 px-1 rounded text-white bg-green-600 hover:bg-green-800" @click="addClass">Add Class</button>
                </div>
              </div>
            </div>
            <div v-if="classes" id="label-row" class="sticky top-0 bg-white border-b p-2 hidden md:block">
              <div class="flex space-x-0">
                <div class="w-8"></div>
                <div class="w-full">
                  <label class="text-xs font-bold">Class Name</label>
                </div>
                <div class="flex space-x-2 items-start" v-if="baseConfig.class_calc !== 'none'">
                  <div v-if="baseConfig.class_calc === 'date_range'" class="w-32">
                    <label class="text-xs font-bold">Start Date</label>
                  </div>
                  <div v-else-if="baseConfig.class_calc === 'age'" class="w-16">
                    <label class="text-xs font-bold">Start Age</label>
                  </div>
                  <div v-if="baseConfig.class_calc === 'date_range'" class="w-32">
                    <label class="text-xs font-bold">End Date</label>
                  </div>
                  <div v-else-if="baseConfig.class_calc === 'age'" class="w-16">
                    <label class="text-xs font-bold">End Age</label>
                  </div>
                </div>
                <div class="w-48 flex-shrink-0" v-if="selectedTemplate.config.class_sub_divisions">
                  <label class="text-xs font-bold">Sub Division</label>
                </div>
                <div class="w-24 flex-shrink-0"></div>
              </div>
            </div>
            <draggable tag="div" v-model="selectedTemplate.config.classes" ghost-class="ghost" handle=".handle" class="bg-white px-2" @end="classDragEnd" v-if="classes">
              <div v-for="(c, i) in selectedTemplate.config.classes" :key="i" class="flex justify-between items-center py-2 border-b">
                <div>
                  <div class="handle draggable mr-3">&#9776;</div>
                </div>
                <div class="w-full">
                  <div class="flex flex-col md:flex-row space-y-1 md:space-y-0 space-x-0 md:items-center">
                    <div class="w-full pr-1">
                      <input v-model="c.class_name" class="text-sm border rounded-md px-2 py-1 w-full">
                    </div>
                    <div class="flex space-x-1 items-start pr-1" v-if="baseConfig.class_calc !== 'none' && !c.is_champion">
                      <div v-if="baseConfig.class_calc === 'date_range'">
                        <input class="py-1 px-2 border block rounded-md w-32 text-sm" v-model="c.start_date" type="date">
                      </div>
                      <div v-else-if="baseConfig.class_calc === 'age'">
                        <input class="py-1 px-2 border block_ rounded-md w-16 text-sm" v-model="c.start_date" type="number">
                      </div>
                      <div v-if="baseConfig.class_calc === 'date_range'">
                        <input class="py-1 px-2 border block rounded-md w-32 text-sm" v-model="c.end_date" type="date">
                      </div>
                      <div v-else-if="baseConfig.class_calc === 'age'">
                        <input  class="py-1 px-2 border block_ rounded-md w-16 text-sm" v-model="c.end_date" type="number">
                      </div>
                    </div>
                    <div v-if="selectedTemplate.config.class_sub_divisions" class="w-48 pr-1 flex-shrink-0">
                      <input v-model="c.sub_division" class="text-sm border rounded-md px-2 py-1 w-full">
                    </div>
                    <div class="w-full md:w-24 flex-shrink-0 flex md:flex-col space-x-2 md:space-x-0 flex-row">
                      <div class="flex items-center">
                        <input v-model="c.is_champion" type="checkbox">
                        <label class="ml-0.5 text-xs">Champion</label>
                      </div>
                      <div class="flex items-center" v-if="selectedTemplate.config.break_type !== 'weight' && !c.is_champion">
                        <input v-model="c.by_weight" type="checkbox">
                        <label class="ml-0.5 text-xs">By Weight</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class=" justify-end flex space-x-1 items-center pl-1">
                  <button @click="removeClass(c, i)" type="button" class="rounded-full border border-red-600 bg-red-600_ p-1 text-white shadow-sm hover:bg-red-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-2.5 h-2.5 text-red-500">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </expandable>

    </div>

    <b-modal ref="preview">
      <preview-class-list class="mt-2" :config="selectedTemplate.config" />
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Vue from 'vue'
import Expandable from '@/components/Expandable'

export default {
  name: 'SimpleClassListConfig',
  components: {
    draggable,
    Expandable
  },
  props: {
    selectedTemplate: Object,
    breeds: Array,
    level: {
      type: Number,
      default: 0
    },
    baseConfig: Object
  },
  data () {
    return {
      addDivisions: false,
      editingDivision: null,
      advancedDivisionEditing: false,
      availableDivisions: [],
      addDivisionType: null,
      breedGroupName: '',
      customDivisionName: '',
      editingBreedGroup: null,
      editClasses: false,
      baseNameHelpText: 'Base name for show (i.e. Market Hog, Breeding Doe etc.).',
      championNameHelpText: 'Base name to use for the just the champion classes. Useful when you want to use a different name just for the Champion Classes. (i.e. Showmanship vs Showman or Steer vs Market Animal)',
      noClassNameHelpText: 'By default this base name is used in each class name with the division prefixed in front (e.g. Berkshire Market Hog, Angus Breeding Heifer). If you dont\'t want this base name to be inlcuded as the name for each class check this box and the base name will only be used for the Overall champion class names.',
      noDivChampionNameHelpText: 'By default this champion name will be used for both overall and division champions. If you only want to modify the overall champion name check this box.',
      baseBreakHelpText: 'How will most classes/divisons be sorted or broken? Individual divisions can have a different break type specified within the division settings.',
      overallChampionHelpText: 'How many overall champions will be selected?',
      divisionChampionHelpText: 'How many champions will be selected from each division?',
      overallChampionTitleHelpText: 'How do you want to refer your overall champion?',
      divisionChampionTitleHelpText: 'How do you refer to your division champions?',
      ageCalcTypeHelpText: 'Will you have preset age classes? If so specify whether you will use a date range (e.g. 1/1/23 to 2/28/23) or specific age (e.g. 3-6 Months).',
      baseDateHelpText: 'What is the date used for determining ages (i.e. age as of Jan 1st 2024).',
      useDayOfShowHelpText: 'If you want to use the day of the show for determining ages check this box. This will override the set base date.',
      ageGapHelpText: 'Do your specific ages leave a gap? (e.g. 0-8, 9-12, 13-18). If so make sure to check this box.',
      noClassesHelpText: 'Will ignore any classes that have been set up for this division.',
      adminOnlyHelpText: 'Will only show this division as an entry option on the admin side.',
      useOnlyDivisionNameHelpText: 'Will only use the division name for the class name. This is useful if you want to use the division name as the class name and not have the base name included. (e.g. for the Market Heifer division).',
      championTitleOptions: [
        {
          label: 'Champion',
          value: 'Champion'
        },
        {
          label: 'Overall Champion',
          value: 'Overall'
        },
        {
          label: 'Grand Champion',
          value: 'Grand'
        },
        {
          label: 'Supreme Champion',
          value: 'Supreme'
        },
        {
          label: 'Best In Show',
          value: 'Best In Show'
        }
      ]
    }
  },
  computed: {
    adminData () {
      return this.$store.state.admin.adminData
    },
    event () {
      return this.adminData.event
    },
    classes () {
      return this.selectedTemplate.config.classes ? this.selectedTemplate.config.classes.length : 0
    },
    divisions () {
      return this.selectedTemplate.config.divisions ? this.selectedTemplate.config.divisions.length : 0
    },
    hasAgeSettings () {
      return this.baseConfig.class_calc === 'age' || this.baseConfig.class_calc === 'date_range'
    }
  },
  methods: {
    isBreed (d) {
      let isBreed = false
      this.breeds.forEach(b => {
        let alias = []
        if (b.alias) {
          alias = b.alias.split(',')
          alias.unshift(b.breed)
        }
        if (b.breed === d.name || alias.includes(d.name)) {
          isBreed = true
        }
        if (b.variants) {
          b.variants.split(',').forEach(v => {
            if (`${v} ${b.breed}` === d.name) {
              isBreed = true
            }
          })
        }
      })
      return isBreed
    },
    getBreedAliasList (breed) {
      let returnAlias = []
      this.breeds.forEach(b => {
        let alias = []
        if (b.alias) {
          alias = b.alias.split(',')
          alias.unshift(b.breed)
        }
        if (b.breed === breed || alias.includes(breed)) {
          returnAlias = alias
        }
      })
      return returnAlias
    },
    addDivisionsClicked (type) {
      this.addDivisionType = type
      if (type === 'breed' || type === 'breed_group') {
        let divisionList = []
        this.breeds.forEach(b => {
          let alias = [b.breed]
          if (b.alias) {
            alias = b.alias.split(',')
            alias.unshift(b.breed)
          }
          let index = -1
          if (this.selectedTemplate.config.divisions) {
            index = this.selectedTemplate.config.divisions.findIndex(obj => obj.name === b.breed || alias.includes(obj.name) || ((obj.division_type === 'breed_group') ? obj.breeds.some(breed => alias.includes(breed)) : false))
          }
          if (alias.length === 1) {
            alias = []
          }
          let isInBreedGroup = false
          if (this.editingBreedGroup) {
            isInBreedGroup = this.editingBreedGroup.breeds.includes(b.breed)
          }
          if (index < 0 || isInBreedGroup) {
            let variants = []
            if (b.variants) {
              b.variants.split(',').forEach(v => {
                let vIndex = -1
                if (this.selectedTemplate.config.divisions) {
                  vIndex = this.selectedTemplate.config.divisions.findIndex(obj => obj.name === `${v} ${b.breed}`)
                }
                if (vIndex < 0) {
                  variants.push({
                    division_type: 'breed',
                    name: `${v} ${b.breed}`,
                    base_breed: b.breed,
                    breeds: [...alias],
                    classes: [],
                    divisions: [],
                    include: isInBreedGroup,
                    break_type: this.selectedTemplate.config.break_type,
                    champions: this.selectedTemplate.config.division_champions,
                    division_champions: 2,
                    champion_title: this.selectedTemplate.config.division_champion_title
                  })
                }
              })
            }
            divisionList.push({
              division_type: 'breed',
              classes: [],
              divisions: [],
              name: b.breed,
              breeds: [b.breed],
              description: b.description,
              variants: variants,
              alias: alias,
              include: isInBreedGroup,
              break_type: this.selectedTemplate.config.break_type,
              champions: this.selectedTemplate.config.division_champions,
              division_champions: 2,
              champion_title: this.selectedTemplate.config.division_champion_title
            })
          }
        })
        this.availableDivisions = divisionList
      }
      this.addDivisions = true
    },
    addSelectedDivisions () {
      let breeds = []
      if (!this.selectedTemplate.config.divisions) {
        Vue.set(this.selectedTemplate.config, 'divisions', [])
      }
      this.availableDivisions.forEach(b => {
        if (b.variants.length) {
          b.variants.forEach(v => {
            if (v.include) {
              if (this.addDivisionType === 'breed') {
                this.selectedTemplate.config.divisions.push(v)
                Vue.set(this.selectedTemplate.config.divisions, this.selectedTemplate.config.divisions.length - 1, v)
              } else if (this.addDivisionType === 'breed_group') {
                breeds.push(...v.breeds)
              }
            }
          })
        }
        if (b.include) {
          if (this.addDivisionType === 'breed') {
            this.selectedTemplate.config.divisions.push(b)
            Vue.set(this.selectedTemplate.config.divisions, this.selectedTemplate.config.divisions.length - 1, b)
          } else if (this.addDivisionType === 'breed_group') {
            breeds.push(...b.breeds)
          }
        }
      })
      if (this.addDivisionType === 'breed_group') {
        if (!this.breedGroupName) {
          this.notie.alert({
            type: 'error',
            text: 'Please enter a name for the breed group.',
            time: 3
          })
          return
        }
        if (!this.editingBreedGroup) {
          this.selectedTemplate.config.divisions.push({
            division_type: 'breed_group',
            breeds: breeds,
            classes: [],
            divisions: [],
            name: this.breedGroupName,
            break_type: this.selectedTemplate.config.break_type,
            champions: this.selectedTemplate.config.division_champions,
            division_champions: 2,
            champion_title: this.selectedTemplate.config.division_champion_title
          })
        } else {
          this.editingBreedGroup.breeds = breeds
          this.editingBreedGroup.name = this.breedGroupName
          this.editingBreedGroup = null
        }
      }
      this.addDivisionType = ''
      this.breedGroupName = ''
      this.addDivisions = false
    },
    removeDivisionClicked (d, i) {
      if (this.selectedTemplate.class_configuration_id) {
        this.notie.confirm({
          text: 'Are you sure you want to remove this division?',
          submitCallback: () => {
            this.removeDivision(d, i)
          }
        })
      } else {
        this.removeDivision(d, i)
      }
    },
    async removeDivision (d, i) {
      let canRemove = await this.$store.state.apiInstance.get(`/checkRemoveDivision?division=${encodeURIComponent(d.name)}&class_list=${this.selectedTemplate.class_configuration_id}`)
      if (canRemove.data.entries === 0) {
        this.selectedTemplate.config.divisions.splice(i, 1)
        this.notie.alert({
          type: 'success',
          text: `${d.name} has been removed.`,
          time: 2
        })
      } else {
        this.notie.alert({
          type: 'error',
          text: 'This division currently has an entry and cannot be removed.',
          time: 5
        })
      }
    },
    editDivision (d, i) {
      this.$store.state.apiInstance.get(`/checkRemoveDivision?division=${encodeURIComponent(d.name)}&class_list=${this.selectedTemplate.class_configuration_id}`)
        .then(response => {
          Vue.set(d, 'canEdit', response.data.entries === 0)
        })

      this.editingDivision = d
      this.selectedTemplate.config.divisions.forEach(d => {
        Vue.set(d, 'edit', false)
      })
      Vue.set(this.selectedTemplate.config.divisions[i], 'edit', true)
    },
    addCustomDivision () {
      if (!this.customDivisionName) {
        this.notie.alert({
          type: 'error',
          text: 'Please enter a name for the custom divison.',
          time: 3
        })
        return
      }
      this.selectedTemplate.config.divisions.push({
        division_type: 'custom',
        breeds: [],
        classes: [],
        divisions: [],
        name: this.customDivisionName,
        break_type: this.selectedTemplate.config.break_type,
        champions: this.selectedTemplate.config.division_champions,
        division_champions: 2,
        champion_title: this.selectedTemplate.config.division_champion_title
      })
      this.customDivisionName = ''
    },
    editBreedGroup (d) {
      this.editingBreedGroup = d
      this.breedGroupName = d.name
      this.addDivisionsClicked('breed_group')
    },
    addClass () {
      if (!this.classes) {
        Vue.set(this.selectedTemplate.config, 'classes', [])
      }

      this.selectedTemplate.config.classes.push({
        class_name: '',
        sub_division: '',
        is_champion: false,
        by_weight: false,
        start_date: '',
        end_date: ''
      })

      if (this.selectedTemplate.config.divisions.length) {
        this.selectedTemplate.config.divisions.forEach(d => {
          if (d.class_ids) {
            d.class_ids.push(`TEMP-${this.selectedTemplate.config.classes.length - 1}`)
          }
        })
      }
    },
    removeClass (c, i) {
      this.selectedTemplate.config.classes.splice(i, 1)

      if (this.selectedTemplate.config.divisions.length) {
        this.selectedTemplate.config.divisions.forEach(d => {
          if (d.class_ids) {
            d.class_ids.splice(i, 1)
          }
        })
      }
    },
    editClass (c, i) {
      this.selectedTemplate.config.classes.forEach(c => {
        Vue.set(c, 'edit', false)
      })
      Vue.set(this.selectedTemplate.config.classes[i], 'edit', true)
    },
    classDragEnd (event) {
      if (this.selectedTemplate.config.divisions.length) {
        this.selectedTemplate.config.divisions.forEach(d => {
          if (d.class_ids) {
            const movedItem = d.class_ids.splice(event.oldIndex, 1)[0]
            d.class_ids.splice(event.newIndex, 0, movedItem)
          }
        })
      }
    },
    divisionChampionsChanged () {
      // Set division champions for all divisions
      this.selectedTemplate.config.divisions.forEach(d => {
        Vue.set(d, 'champions', this.selectedTemplate.config.division_champions)
      })
    },
    breakTypeChanged () {
      // Set break type for all divisions
      this.selectedTemplate.config.divisions.forEach(d => {
        Vue.set(d, 'break_type', this.selectedTemplate.config.break_type)
      })
    },
    divisionChampionTitleChanged () {
      // Set break type for all divisions
      this.selectedTemplate.config.divisions.forEach(d => {
        Vue.set(d, 'champion_title', this.selectedTemplate.config.division_champion_title)
      })
    },
    setHasSubdivisions () {
      Vue.set(this.selectedTemplate.config, 'class_sub_divisions', this.selectedTemplate.config.class_sub_divisions)
      this.$forceUpdate()
    },
    formatDate: function (date) {
      return this.Localized.formatDate(date, this.event.location_details.country)
    },
    checkForAdvancedReset () {
      if (!this.selectedTemplate.config.advanced_name_settings) {
        this.selectedTemplate.config.champion_name = null
        this.selectedTemplate.config.no_name_in_div_champion_class = false
      }
    },
    fixDivisionData () {
      this.selectedTemplate.config.divisions.forEach(d => {
        if (!d.classes) {
          Vue.set(d, 'classes', [])
        }
        if (!d.divisions) {
          Vue.set(d, 'divisions', [])
        }
        if (d.edit) {
          d.edit = false
        }
      })
    },
    hasClasses (d) {
      if (d.classes) {
        return d.classes.length
      } else {
        return 0
      }
    },
    hasDivisions (d) {
      if (d.divisions) {
        return d.divisions.length
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.fixDivisionData()
    if (!this.selectedTemplate.config.classes) {
      Vue.set(this.selectedTemplate.config, 'classes', [])
    }
    if (!this.selectedTemplate.config.divisions) {
      Vue.set(this.selectedTemplate.config, 'divisions', [])
    }
  },
  watch: {
    'selectedTemplate.config' () {
      this.fixDivisionData()
    }
  }
}
</script>

<style>
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
  .draggable:hover {
    cursor: grab;
  }

  .tooltip {
    max-width: 28rem;
  }
  .tooltip .tooltip-inner {
    padding: 8px 10px;
    border-radius: 6px;
    background: black;
    color:white;
  }
</style>
